import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useProjectMembers } from '../hooks/useProjectMembers';
import { addProjectMember, updateMemberRole, removeMember } from '../utils/memberUtils';
import AddMemberForm from './members/AddMemberForm';
import MemberItem from './members/MemberItem';
import {
    MembersContainer,
    MembersList,
    SectionTitle
} from '../styles/ProjectMembers.styles';

export function ProjectMembers({ projectId, currentUserRole }) {
    const { user } = useAuth();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { members, memberDetails, error: membersError } = useProjectMembers(projectId);

    const handleAddMember = async (e) => {
        e.preventDefault();
        if (!email.trim()) return;
        setLoading(true);
        setError('');

        try {
            await addProjectMember(projectId, email, user);
            setEmail('');
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleRoleChange = async (memberId, newRole) => {
        if (currentUserRole !== 'admin') return;
        try {
            await updateMemberRole(projectId, memberId, newRole);
        } catch (error) {
            console.error('Error updating member role:', error);
        }
    };

    const handleRemoveMember = async (memberId) => {
        if (currentUserRole !== 'admin' || memberId === user.uid) return;
        try {
            await removeMember(projectId, memberId);
        } catch (error) {
            setError(error.message);
        }
    };

    return (
        <MembersContainer>
            <SectionTitle>Project Members</SectionTitle>
            {currentUserRole === 'admin' && (
                <AddMemberForm
                    email={email}
                    loading={loading}
                    error={error || membersError}
                    onEmailChange={setEmail}
                    onSubmit={handleAddMember}
                />
            )}
            <MembersList>
                {Object.entries(members).map(([userId, memberData]) => (
                    <MemberItem
                        key={userId}
                        userId={userId}
                        memberData={memberData}
                        userData={memberDetails[userId] || {}}
                        currentUserRole={currentUserRole}
                        isCurrentUser={userId === user.uid}
                        onRoleChange={handleRoleChange}
                        onRemove={handleRemoveMember}
                    />
                ))}
            </MembersList>
        </MembersContainer>
    );
}

export default ProjectMembers;